// Arabische teksten voor gemiste taken in de ouderapp (zie missedApp.nl.ts); de app zet ze in RTL.
export const appMissedAr = {
    line: {
        zero: 'لا مهام فائتة في الأسبوع الماضي',
        one: 'مهمة واحدة فائتة في الأسبوع الماضي',
        two: 'مهمتان فائتتان في الأسبوع الماضي',
        few: '{count} مهام فائتة في الأسبوع الماضي',
        many: '{count} مهمة فائتة في الأسبوع الماضي',
        other: '{count} مهمة فائتة في الأسبوع الماضي',
    },
    lineSub: 'إنجازها متأخرًا أو تخطيها',
    open: 'عرض',
    title: 'الفائتة',
    description: 'مهام من الأسبوع الماضي بقيت مفتوحة. ضع عليها علامة الإنجاز متأخرًا أو تخطَّها. تُحسب النقاط كما في ذلك اليوم.',
    done: 'أُنجزت متأخرًا',
    doneLabel: 'أُنجزت متأخرًا: {title}، {name}',
    skip: 'تخطٍّ',
    skipLabel: 'تخطٍّ: {title}، {name}',
    undo: 'تراجع',
    undoLabel: 'تراجع: {title}، {name}',
    markedDone: 'تم إنجاز {title} متأخرًا',
    markedSkipped: 'تم تخطي {title}',
    undone: 'عادت {title} إلى الفائتة',
    stateDone: 'أُنجزت',
    stateSkipped: 'تم التخطي',
    allDone: 'لا شيء فائت بعد الآن. كل شيء محدَّث.',
};
//# sourceMappingURL=missedApp.ar.js.map